import { render, staticRenderFns } from "./ATGReportTabs.vue?vue&type=template&id=685fdc5e&scoped=true"
import script from "./ATGReportTabs.vue?vue&type=script&lang=js"
export * from "./ATGReportTabs.vue?vue&type=script&lang=js"
import style1 from "./ATGReportTabs.vue?vue&type=style&index=1&id=685fdc5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685fdc5e",
  null
  
)

export default component.exports